module.exports = __webpack_public_path__ + "static/media/home-gastronomy.01f0eec1.jpg";